import React from "react";
import { useLocation, BrowserRouter } from "react-router-dom";

const withLocation = (Component) => (props) => {
  try {
    const location = useLocation();
    return <Component {...props} location={location} />;
  } catch (error) {
    console.warn("withLocation must be used inside a Router. Wrapping in BrowserRouter.");
    return (
      <BrowserRouter>
        <Component {...props} location={{ pathname: "/", state: null, search: "", hash: "" }} />
      </BrowserRouter>
    );
  }
};

export default withLocation;
